import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 container mx-auto flex items-center justify-center" }
const _hoisted_2 = { class: "bg-white shadow-md w-[50%] p-8 rounded-md" }
const _hoisted_3 = { class: "pt-3" }




export default /*#__PURE__*/_defineComponent({
  __name: 'FormWrapper',
  props: { title: String },
  emits: ["submit"],
  setup(__props, { emit }) {

const props = __props;




const handleSubmit = (e) => {
  emit("submit", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: handleSubmit,
        class: "text-left p-4 p-lg-5"
      }, [
        _createElementVNode("h2", null, _toDisplayString(props.title), 1),
        _renderSlot(_ctx.$slots, "content"),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "buttons")
        ])
      ], 32)
    ])
  ]))
}
}

})